import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import SenderNameSchema from "notifications/senders/sender-name-schema";

export default class SenderName {
  public static fromJSON(value: unknown): SenderName | null | undefined {
    if (isNullOrUndefined(value)) return value;
    const params = SenderNameSchema.deserialize(value);
    return new SenderName(params);
  }

  public get value(): string {
    return this._value;
  }

  public constructor(value: string) {
    this._value = value;
  }

  public toJSON(): string {
    return this.value;
  }

  public clone(): SenderName {
    return new SenderName(this.value);
  }

  public isEqualTo(other: SenderName): boolean {
    return this.value === other?.value;
  }

  public toString(): string {
    return this.value;
  }

  private readonly _value: string;
}
